export default "__VITE_ASSET__DM_jVC4W__"